import React from 'react';
import { GenericFormPage } from '../../../components/generic';
import { usePmsMeasurementResult, PmsMeasurementResult } from './useData';
import { moduleConfig, getInitialFormData, mapItemToFormData } from './config';

const Form: React.FC = () => (
  <GenericFormPage<PmsMeasurementResult>
    useData={usePmsMeasurementResult}
    config={{
      ...moduleConfig,
      getInitialFormData,
      mapItemToFormData,
    }}
  />
);

export default Form;
